export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-thumbnail-960-d3a37369373e70066252428fda7878b6.webp";